<template>
  <div>
    <nav-breadcrumb :menu="[{label: '合同申请列表'}]"/>
    <el-row class="bg-purple">
      <el-col class="grid-content">
        <el-row>
          <el-tabs v-model="applicationStatus">
            <el-tab-pane label="待审核" name="Pending Approval" />
            <el-tab-pane label="已审核" name="Approved, Rejected" />
          </el-tabs>
          <data-table
            :tableData="contractApplyingListData"
            :columns="contractApplyingListColumns"
            :filters="filters"
            :pageSize.sync="pageSize"
            :page.sync="page"
            class="xzmLR10"
          ></data-table>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";

  export default {
    name: 'ServerAdminContractApplyingList',
    data() {
      return {
        applicationStatus: 'Pending Approval',
        page: 1,
        pageSize: 10,
        contractApplyingListData: {},
        filters: {
          form: {
            ct__applicationNo: '',
            u__customerName: '',
            ct__productName: '',
            ct__applicationDate: [],
            ct__remarks: ''
          },
          columns: [
            {
              label: '合同申请号',
              component: 'el-input',
              field: 'ct__applicationNo'
            },
            {
              label: '客户名称',
              component: 'el-input',
              field: 'u__customerName'
            },
            {
              label: '融资产品',
              component: 'el-input',
              field: 'ct__productName'
            },
            {
              label: '申请日期',
              component: 'date-range-picker',
              field: 'ct__applicationDate'
            },
            {
              label: '申请备注',
              component: 'el-input',
              field: 'ct__remarks'
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerApplyingContractList()
          }
        }
      }
    },
    computed : {
      contractApplyingListColumns: function() {
        return [
          {
            name: '合同申请号',
            field: 'ct__applicationNo'
          },
          {
            name: '客户名称',
            field: 'u__customerName'
          },
          {
            name: '申请日期',
            field: 'ct__applicationDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '供应链',
            field: 'ct__debtorName'
          },
          {
            name: '融资产品',
            field: 'ct__productName',
          },
          {
            name: '合同起始日',
            field: 'ct__expectedContractValidity1',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '合同到期日',
            field: 'ct__expectedContractValidity2',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '利率',
            field: 'ct__expectedInterestRate',
            formatter:function (r,c,v) {
              return v+'% ('+ Status2CN(r.ct__expectedInterestType) +')'
            }
          },
          {
            name: '服务费',
            field: 'ct__expectedLendingFee',
            formatter: function (r,c,v) {
              return v+ (r.ct__expectedLendingFeeType == 'Rate' ? '%' : ' 元')
            }
          },
          {
            name: '申请备注',
            field: 'ct__remarks',
          },
          {
            name: '申请状态',
            field: 'ct__applicationStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '操作',
            opts: [
              {
                class: 'el-icon-success',
                name: '审核',
                clickHandler: (index, row)=>{
                  this.viewDetail(index, row)
                },
                conditions: (row)=>{
                  return row.ct__applicationStatus == 'Pending Approval'
                }
              },
              {
                class: 'el-icon-info',
                name: '查看',
                clickHandler: (index, row)=>{
                  this.viewDetail(index, row)
                }
              },
            ]

          }
        ]
      },
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.ct.applicationStatus': this.applicationStatus,
            'xlist.search.ct.applicationStatus.op': 'in',
            'xlist.sort.dataField': 'ct.applicationDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerApplyingContractList()
      }
    },
    mounted() {
      this.getCustomerApplyingContractList()
    },
    methods: {
      getCustomerApplyingContractList: function () {
        xhr.getCustomerApplyingContractList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.contractApplyingListData = res.data
            }catch(e){

            }
        })

      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({path: 'ApplyingDetail?ct.applicationId='+ row.ct__applicationId})
        }
        catch (e) {

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/ContractApplyingList.vue